import { useCallback } from 'react';

import { ClockControlType } from '@features/shared/api/typings';
import { PlayerEloStatWidget } from '@features/user/ui/PlayerEloStats/PlayerEloStat/PlayerEloStatWidget';
import { PlayerEloStats } from '@features/user/ui/PlayerEloStats/PlayerEloStats';
import { PlayerGamesListFullWidget } from '@features/user/ui/PlayerGamesListFull/PlayerGamesListFullWidget';

type Props = {
  onClose?: () => void;
  openFullGamesListClockControlType?: ClockControlType;
  setOpenFullGamesList?: (clockControlType?: ClockControlType) => void;
};
export function PlayerEloStatsWidget({
  onClose,
  openFullGamesListClockControlType,
  setOpenFullGamesList,
}: Props) {
  const openBullet = useCallback(() => {
    setOpenFullGamesList?.('Bullet');
  }, [setOpenFullGamesList]);
  const openBlitz = useCallback(() => {
    setOpenFullGamesList?.('Blitz');
  }, [setOpenFullGamesList]);
  const openRapid = useCallback(() => {
    setOpenFullGamesList?.('Rapid');
  }, [setOpenFullGamesList]);
  const closeFullGamesList = useCallback(() => {
    setOpenFullGamesList?.(undefined);
  }, [setOpenFullGamesList]);

  return (
    <>
      <PlayerEloStats isOpen={openFullGamesListClockControlType === undefined} onClose={onClose}>
        <PlayerEloStatWidget clockControlType="Bullet" openShowFullGamesList={openBullet} />

        <PlayerEloStatWidget clockControlType="Blitz" openShowFullGamesList={openBlitz} />
        <PlayerEloStatWidget clockControlType="Rapid" openShowFullGamesList={openRapid} />
      </PlayerEloStats>

      <PlayerGamesListFullWidget
        isOpen={openFullGamesListClockControlType === 'Bullet'}
        onClose={closeFullGamesList}
        clockControlType="Bullet"
      />
      <PlayerGamesListFullWidget
        isOpen={openFullGamesListClockControlType === 'Blitz'}
        onClose={closeFullGamesList}
        clockControlType="Blitz"
      />
      <PlayerGamesListFullWidget
        isOpen={openFullGamesListClockControlType === 'Rapid'}
        onClose={closeFullGamesList}
        clockControlType="Rapid"
      />
    </>
  );
}
